import type { RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { memo } from 'react';

import styles from './helocSubtitle.module.scss';

interface HelocSubtitleProps {
  subtitle: RichTextField;
  isVisible: boolean;
}

const components: JSXMapSerializer = {
  heading5: ({ children }) => <h5 className={styles.subtitle}>{children}</h5>,
};

const HelocSubtitleComponent = ({
  subtitle,
  isVisible,
}: HelocSubtitleProps) => {
  return (
    <div
      className={`${styles.subtitle_wrapper} ${isVisible ? styles.isVisible : ''}`}
    >
      <PrismicRichText field={subtitle} components={components} />
    </div>
  );
};

export const HelocSubtitle = memo(HelocSubtitleComponent);
